import { DEFAULT_LIST_PAGE_SIZE } from 'src/util/constants';

/**
 * Returns reset variables for retrying the `PortfolioListRoute_Query`.
 * The GraphQL query accepts `$count: Int` and `$cursor: String` (both optional).
 * On retry the cursor is intentionally omitted so Relay fetches the first page
 * fresh, discarding any in-progress pagination cursor from the faulted request.
 * `count` is set to `DEFAULT_LIST_PAGE_SIZE` so the retry page size matches the
 * initial load issued by `prepareVariables` in `src/routes/index.jsx`.
 * Returning an object (not `null`) keeps the boundary retry button enabled.
 * @returns {{ count: number }} First-page reset variables.
 */
function getPortfolioListRetryVariables() {
  return { count: DEFAULT_LIST_PAGE_SIZE };
}

export default getPortfolioListRetryVariables;
